import { render, staticRenderFns } from "./ReportCardPieChartView.vue?vue&type=template&id=4508b30c&scoped=true"
import script from "./ReportCardPieChartView.vue?vue&type=script&lang=js"
export * from "./ReportCardPieChartView.vue?vue&type=script&lang=js"
import style0 from "./ReportCardPieChartView.vue?vue&type=style&index=0&id=4508b30c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508b30c",
  null
  
)

export default component.exports